import React from "react";
import { Popup } from "../../../../UI/Popup/Popup";
import { SvgIcons } from "../../../SharedComponents/SvgIcons/SvgIcons";
import EmphasizedMessage from "../EmphasizedMessage";
import styles from "./WarningConfirmModal.module.css";

/**
 * A backend warning to confirm before the write goes through (catalogue § 4):
 * the mentor's leave in the batch window, the projected completion past the
 * course's validity, or the weekly quota breached. A warning is not a failure —
 * confirming resends the same request with the warning accepted. The message is
 * the backend's, written for the ops user, and shown as it comes, with its dates
 * and batch ids in bold.
 *
 * @param {{ warning: {title: string, message: string}|null,
 *           confirmLabel?: string, submitting?: boolean,
 *           onCancel: () => void, onConfirm: () => void }} props
 */
const WarningConfirmModal = ({
  warning,
  confirmLabel = "Continue anyway",
  submitting,
  onCancel,
  onConfirm,
}) => {
  if (!warning) return null;

  const { title, message } = warning;

  return (
    <Popup onClose={onCancel} contentClassName={styles.popupShell} showCloseIcon={false}>
      <div className={styles.modal} role="dialog" aria-label={title}>
        <h3 className={styles.title}>
          <SvgIcons name="exclamation_circle_filled" className={styles.icon} width="20" height="20" />
          {title}
        </h3>
        <p className={styles.message}>
          <EmphasizedMessage text={message} />
        </p>
        <div className={styles.actions}>
          <button type="button" className={styles.cancel} onClick={onCancel}>
            Go back
          </button>
          <button type="button" className={styles.confirm} disabled={submitting} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </Popup>
  );
};

export default WarningConfirmModal;
